 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		47: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		47: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app." + ({"7":"DeprecatedStyles","13":"EnhancedStyles","14":"app-components-Workflow-WorkflowContainer","15":"app-components-bibs-BibPage-BibPageContainer","16":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","17":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","18":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","19":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","20":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","21":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","22":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","23":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","24":"app-components-bibs-subpages-CommentPage-CommentPageContainer","25":"app-components-bibs-subpages-MarcPage-MarcPageContainer","26":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","27":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","28":"app-components-bibs-subpages-VideoPage-VideoPageContainer","29":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","30":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","31":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","32":"app-components-borrowing-fines-Fines-FinesContainer","33":"app-components-borrowing-holds-Holds-HoldsContainer","34":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","35":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","36":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","37":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","38":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","39":"app-components-events-EventsSearchPage-EventsSearchPageContainer","40":"app-components-locations-LocationsPage-LocationsPageContainer","41":"app-components-search-Search-SearchContainer","42":"app-components-search-SearchPrintList-SearchPrintListContainer","43":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","44":"app-components-shelves-Shelf-ShelfContainer","45":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","46":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"52692a15db103412a361","1":"503e4543339ba24a4dcd","2":"22c9b66592b7c3381fe5","3":"2c9f8b8a982d235d88b6","4":"9a8ed9b3381873d9c8eb","5":"a288d13992cf2a7e4d4d","6":"e60b88ebb98678c80bec","7":"c1a18c33fe6ca59a62f1","8":"fe7c2eebb9a095ac548c","9":"6e48a05977758febfae7","10":"288c73514ed441fc70db","11":"773b1f0f5401984633b3","12":"6e5630e10607f0b9265a","13":"4f22c5d55dce04de7a33","14":"c65f798ab10a5b55d3ec","15":"3ae94a745c18f928048e","16":"4c2fb2c59b19f294e5f9","17":"779159df834dfeb2d037","18":"dbd18feb9a21a45bac93","19":"6890d977ed6ccc797a5c","20":"4976ccfa22d50be2c0a5","21":"56589095ef04ad4b4420","22":"8b08958ce10bb29ee3f4","23":"0d2465773d71d3c115e6","24":"96bc044b48306c6c9131","25":"398e10b537ae0a258274","26":"dc27aedaf44b3a43954c","27":"7daa3e150d73405cbe40","28":"f915f720c134a779fc44","29":"3de4136abfc857507f98","30":"3bfd49db53e617a89d7a","31":"0862ebd26f454b5140ce","32":"0d16d847330c15cd84db","33":"7ed93ec8f8ca592cc9b8","34":"2b3f4d05a5fdd8b1c857","35":"ca67653184b38f944b3e","36":"73bcaee0272011006039","37":"0b6125d3a0e3f84e9891","38":"988917d024764355d822","39":"0dd33e878602a8e51e0d","40":"79799bf1826ef71fdafe","41":"14a0a78389d14f8a5906","42":"dd70d357f6a149dba89f","43":"b57ade5530ed4d380f17","44":"e61af1ccd4006c078b35","45":"b4109ae9d360c9ac586d","46":"34b539f24d62c9d4cea0","48":"f91cb65e7f420133094a","49":"5931280ebe0ef93cdab7","50":"ddc8c7e93e3297ea26c7","51":"7e46943b022a7888e01c","52":"b80667ac563446813ec6","53":"1a40381834809e9d3c38","54":"843ce94b240c7044f8fd","55":"329349bceaeefa204f4c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"45":1,"46":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app." + ({"7":"DeprecatedStyles","13":"EnhancedStyles","14":"app-components-Workflow-WorkflowContainer","15":"app-components-bibs-BibPage-BibPageContainer","16":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","17":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","18":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","19":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","20":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","21":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","22":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","23":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","24":"app-components-bibs-subpages-CommentPage-CommentPageContainer","25":"app-components-bibs-subpages-MarcPage-MarcPageContainer","26":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","27":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","28":"app-components-bibs-subpages-VideoPage-VideoPageContainer","29":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","30":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","31":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","32":"app-components-borrowing-fines-Fines-FinesContainer","33":"app-components-borrowing-holds-Holds-HoldsContainer","34":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","35":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","36":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","37":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","38":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","39":"app-components-events-EventsSearchPage-EventsSearchPageContainer","40":"app-components-locations-LocationsPage-LocationsPageContainer","41":"app-components-search-Search-SearchContainer","42":"app-components-search-SearchPrintList-SearchPrintListContainer","43":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","44":"app-components-shelves-Shelf-ShelfContainer","45":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","46":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"52692a15db103412a361","1":"503e4543339ba24a4dcd","2":"22c9b66592b7c3381fe5","3":"2c9f8b8a982d235d88b6","4":"9a8ed9b3381873d9c8eb","5":"a288d13992cf2a7e4d4d","6":"e60b88ebb98678c80bec","7":"c1a18c33fe6ca59a62f1","8":"fe7c2eebb9a095ac548c","9":"6e48a05977758febfae7","10":"288c73514ed441fc70db","11":"773b1f0f5401984633b3","12":"6e5630e10607f0b9265a","13":"4f22c5d55dce04de7a33","14":"c65f798ab10a5b55d3ec","15":"3ae94a745c18f928048e","16":"4c2fb2c59b19f294e5f9","17":"779159df834dfeb2d037","18":"dbd18feb9a21a45bac93","19":"6890d977ed6ccc797a5c","20":"4976ccfa22d50be2c0a5","21":"56589095ef04ad4b4420","22":"8b08958ce10bb29ee3f4","23":"0d2465773d71d3c115e6","24":"96bc044b48306c6c9131","25":"398e10b537ae0a258274","26":"dc27aedaf44b3a43954c","27":"7daa3e150d73405cbe40","28":"f915f720c134a779fc44","29":"3de4136abfc857507f98","30":"3bfd49db53e617a89d7a","31":"0862ebd26f454b5140ce","32":"0d16d847330c15cd84db","33":"7ed93ec8f8ca592cc9b8","34":"2b3f4d05a5fdd8b1c857","35":"ca67653184b38f944b3e","36":"73bcaee0272011006039","37":"0b6125d3a0e3f84e9891","38":"988917d024764355d822","39":"0dd33e878602a8e51e0d","40":"79799bf1826ef71fdafe","41":"14a0a78389d14f8a5906","42":"dd70d357f6a149dba89f","43":"b57ade5530ed4d380f17","44":"e61af1ccd4006c078b35","45":"b4109ae9d360c9ac586d","46":"34b539f24d62c9d4cea0","48":"f91cb65e7f420133094a","49":"5931280ebe0ef93cdab7","50":"ddc8c7e93e3297ea26c7","51":"7e46943b022a7888e01c","52":"b80667ac563446813ec6","53":"1a40381834809e9d3c38","54":"843ce94b240c7044f8fd","55":"329349bceaeefa204f4c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-nerf.bibliocommons.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2325);
